import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class TextFieldComponent implements OnInit {

  typeToHTMLTypeMap = {'text': 'text', 'number': 'number', 'password': 'password'};
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() value: any;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() formControlName: string;
  @Input() type: 'text' | 'password' | 'number' = 'text';
  constructor() { }

  get htmlType() {
    return this.typeToHTMLTypeMap[this.type];
  }

  ngOnInit(): void {
  }

}
